module.exports = __webpack_public_path__ + "static/media/ulldeltemps_small@2x.2d697f5b.jpg";